<div class="g-noise"></div>
<!-- ════════════ NAVBAR ════════════ -->
<nav class="unav">
  <div class="container-fluid">
    <a class="unav-brand" routerLink="/">
      <img src="assetses/img/logo.png" alt="UMYOBizDFW">
      <span>UMYO<em>BizDFW</em></span>
    </a>
    <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
    <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
      <li><a href="/">Home</a></li>
      <li><a href="/about">About Us</a></li>
      <li><a routerLink="/networks">Network</a></li>
      <li><a routerLink="/hub" class="active">Hub</a></li>
      <li><a routerLink="/anti-bullying">Anti-Bullying</a></li>
      <li><a routerLink="/community-impact">Community Fund</a></li>
      <li><a routerLink="/empower-youth">Empower Youth</a></li>
      <li><a routerLink="/services">Type of Servcies</a></li>
      <li><a routerLink="/cf">Card Features</a></li>
    </ul>
    <!-- <a href="/#registration-form" class="unav-cta" >Join $2.54/mo</a> -->
  </div>
</nav>

<section class="uhero ns">
  <div class="cg"></div>
  <div class="orb orb1"></div>
  <div class="orb orb2"></div>
  <div class="container" style="padding-top:20px;position:relative;z-index:1;">
    <div class="row align-items-center gy-5">
      <div class="col-lg-7">
        <p class="hero-ey">Dallas–Fort Worth's Community Platform</p>
        <h1 class="hero-t">
          DFW's First<br>Privacy-Gated<br><span class="ac">Digital Community</span>
        </h1>
        <p class="hero-sub">Built for Residents. Powered by Businesses. Focused on Students. A secure, structured platform where Dallas–Fort Worth connects, grows, reinvests, and protects its future.</p>
        <div class="hero-badges">
          <span class="hbg">🔒 Privacy-Gated</span>
          <span class="hbg">🏙️ DFW Exclusive</span>
          <span class="hbg">🥊 Anti-Bullying Backed</span>
          <span class="hbg">💸 Local Reinvestment</span>
        </div>
        <div class="hero-btns">
          <a href="/#registration-form" class="btn-c">🌐 Join for Just $2.54/month</a>
          <a href="/hub#what" class="btn-o">Learn More</a>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-flex justify-content-center">
        <div class="hv">
          <div class="ro">
            <div class="rn">🏙️</div>
            <div class="rn">🥊</div>
            <div class="rn">💼</div>
            <div class="ri"><img src="assetses/img/logo.png" alt="Logo"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="scr">
    <div class="scl"></div>
    <span>Scroll</span>
  </div>
</section>

<!-- ════════════ STATS BAR ════════════ -->
<div class="usb ns">
  <div class="container">
    <div class="ust"><span class="usn">$2.54</span><span class="usl">Monthly Membership</span></div>
    <div class="usd"></div>
    <div class="ust"><span class="usn">20%</span><span class="usl">Anti-Bullying Funding</span></div>
    <div class="usd"></div>
    <div class="ust"><span class="usn">DFW</span><span class="usl">Exclusive Region</span></div>
    <div class="usd"></div>
    <div class="ust"><span class="usn">UFC</span><span class="usl">Fighter Backed</span></div>
    <div class="usd"></div>
    <div class="ust"><span class="usn">100K+</span><span class="usl">Audience Reach</span></div>
  </div>
</div>

<!-- ════════════ SECTION 1 — WHAT IS UMYOBIZDFW ════════════ -->
<section class="uwhat ns" id="what">
  <div class="container">
    <div class="row align-items-center g-5">
      <div class="col-lg-6">
        <p class="lbl " sipScrollReveal [sipDelay]="0">What Is UMYOBizDFW?</p>
        <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">More Than Social Media.<br><span class="ac">This Is Community Infrastructure.</span></h2>
        <div class="dv " sipScrollReveal [sipDelay]="0.16"></div>
        <p class="tx " sipScrollReveal [sipDelay]="0.24" style="margin-bottom:2rem;">UMYOBizDFW is a <strong style="color:var(--cw);">privacy-gated digital community</strong> designed exclusively for Dallas–Fort Worth residents, businesses, schools, and organizations. We eliminate toxic amplification and create a protected ecosystem — built by DFW, for DFW.</p>
        <ul class="ckl">
          <li class="" sipScrollReveal [sipDelay]="0"><span class="ck">✓</span><span><strong>Trust is built</strong> — verified connections, no anonymous toxicity</span></li>
          <li class="" sipScrollReveal [sipDelay]="0.08"><span class="ck">✓</span><span><strong>Data is protected</strong> — your information stays inside DFW</span></li>
          <li class="" sipScrollReveal [sipDelay]="0.16"><span class="ck">✓</span><span><strong>Local dollars circulate locally</strong> — every transaction reinvests in our neighborhoods</span></li>
          <li class="" sipScrollReveal [sipDelay]="0.24"><span class="ck">✓</span><span><strong>Businesses grow affordably</strong> — hyper-local targeting, not random national audiences</span></li>
          <li class="" sipScrollReveal [sipDelay]="0.32"><span class="ck">✓</span><span><strong>Students receive structured support</strong> — mentorship backed by professionals</span></li>
          <li class="" sipScrollReveal [sipDelay]="0.4"><span class="ck">✓</span><span><strong>Community voice is respected</strong> — not exploited by outside platforms</span></li>
        </ul>
        <div class="d-flex flex-wrap gap-3 mt-4" sipScrollReveal [sipDelay]="0">
          <a href="/#registration-form" class="btn-c" >Register Here</a>
          <a href="/hub#economy" class="btn-o">See the Model</a>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row g-3">
          <div class="col-6 " sipScrollReveal [sipDelay]="0.8">
            <div class="uc p-4 text-center h-100">
              <div style="font-size:2rem;margin-bottom:.8rem;">🔐</div>
              <h6 style="font-family:var(--fh);font-size:1rem;letter-spacing:.06em;color:var(--cw);margin-bottom:.4rem;">Privacy Gated</h6>
              <p style="font-size:.82rem;color:var(--cm);margin:0;">No data harvesting. No exploitative algorithms.</p>
            </div>
          </div>
          <div class="col-6" sipScrollReveal [sipDelay]="0.16">
            <div class="uc p-4 text-center h-100">
              <div style="font-size:2rem;margin-bottom:.8rem;">🏘️</div>
              <h6 style="font-family:var(--fh);font-size:1rem;letter-spacing:.06em;color:var(--cw);margin-bottom:.4rem;">DFW Exclusive</h6>
              <p style="font-size:.82rem;color:var(--cm);margin:0;">Built for Dallas–Fort Worth, by Dallas–Fort Worth.</p>
            </div>
          </div>
          <div class="col-6 " sipScrollReveal [sipDelay]="0.24">
            <div class="uc p-4 text-center h-100">
              <div style="font-size:2rem;margin-bottom:.8rem;">💸</div>
              <h6 style="font-family:var(--fh);font-size:1rem;letter-spacing:.06em;color:var(--cw);margin-bottom:.4rem;">Local Economy</h6>
              <p style="font-size:.82rem;color:var(--cm);margin:0;">Every dollar circulates back into our community.</p>
            </div>
          </div>
          <div class="col-6 " sipScrollReveal [sipDelay]="0.32">
            <div class="uc p-4 text-center h-100">
              <div style="font-size:2rem;margin-bottom:.8rem;">🛡️</div>
              <h6 style="font-family:var(--fh);font-size:1rem;letter-spacing:.06em;color:var(--cw);margin-bottom:.4rem;">Zero Negativity</h6>
              <p style="font-size:.82rem;color:var(--cm);margin:0;">Structured environment. No drama. No exploitation.</p>
            </div>
          </div>
        </div>
        <div class=" mt-3" sipScrollReveal [sipDelay]="0.4">
          <div style="background:rgba(0,212,255,.04);border:1px solid rgba(0,212,255,.12);border-radius:12px;padding:1.5rem;text-align:center;">
            <p style="font-style:italic;color:var(--cw);font-size:.95rem;line-height:1.75;margin:0;font-family:var(--fb);">
              "The only platform that combines privacy, community reinvestment, student protection, and local business growth — all in one DFW ecosystem."
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════ SECTION 2 — ANTI-BULLYING ════════════ -->
<section class="uab ns" id="antibully">
  <div class="container">
    <div class="row align-items-center g-5">
      <div class="col-lg-6">
        <p class="lbl " sipScrollReveal [sipDelay]="0">The DFW Anti-Bullying Movement</p>
        <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">Students First.<br><span class="ac">Community First.</span><br>Security First.</h2>
        <div class="dv " sipScrollReveal [sipDelay]="0.16"></div>
        <p class="tx " sipScrollReveal [sipDelay]="0.24">Bullying is not just a school issue. It impacts <strong style="color:var(--cw);">academic performance, mental health, family stability, and long-term confidence</strong>. Sponsored by <strong style="color:var(--cw);">Dallas Security Academy</strong> and backed by professional MMA fighters including <strong style="color:var(--cc);">UFC Fighter Kennedy Nzechukwu</strong>, this structured movement delivers measurable solutions — not hashtags.</p>
        <div class="ufc " sipScrollReveal [sipDelay]="0.32" style="display: flex; align-items: center; gap: 1.2rem; padding: 1.2rem 1.5rem; transition-delay: 0.3s;">
          <div style="flex-shrink:0;width:100px;height:100px;border-radius:50%;border:2px solid rgba(0,212,255,.35);overflow:hidden;box-shadow:0 0 24px rgba(0,212,255,.25);background:#040d18;">
            <img src="assetses/img/Kennedy-Nzechukwu.png" alt="Kennedy Nzechukwu UFC Fighter" style="width:100%;height:100%;object-fit:cover;object-position:top;">
          </div>
          <div>
            <h4 style="margin:0 0 .3rem;">🥊 Kennedy Nzechukwu</h4>
            <p style="font-size:0.84rem; color:rgba(94,232,255,0.8); margin:0;">UFC Professional Fighter &amp; DFW Anti-Bullying Advocate</p>
            <p style="font-size:0.78rem; color:var(--text-muted); margin:.2rem 0 0;">100K+ Platform Reach · Dallas Security Academy Partner</p>
          </div>
        </div>
        <div class="uqb " sipScrollReveal [sipDelay]="0.4">No student should suffer in silence. No family should feel isolated. No young person should face adversity alone.</div>
        <div class="d-flex flex-wrap gap-3 mt-4 " sipScrollReveal [sipDelay]="0.48">
          <a href="/#partner" class="btn-c">Support a Student</a>
          <a href="/#registration-form" class="btn-o">Register Your School</a>
        </div>
      </div>
      <div class="col-lg-6 " sipScrollReveal [sipDelay]="0">
        <p class="lbl mb-3">Through Verified Partnerships, Students Receive:</p>
        <div style="display:flex;flex-wrap:wrap;margin-bottom:2rem;">
          <span class="upill">💪 Strength &amp; Conditioning</span>
          <span class="upill">🥋 Self-Defense Instruction</span>
          <span class="upill">🧠 Life &amp; Behavioral Coaching</span>
          <span class="upill">⭐ Confidence Development</span>
          <span class="upill">🎯 Critical Thinking Skills</span>
          <span class="upill">👨‍👩‍👧 Parental Coaching</span>
          <span class="upill">🏋️ Discipline Training</span>
        </div>
        <div style="display:flex;flex-direction:column;gap:.8rem;">
          <div class="uc p-3" style="display:flex;gap:1rem;align-items:center;">
            <div style="font-size:1.6rem;flex-shrink:0;">🏫</div>
            <div><h6 style="font-size:.92rem;font-weight:600;color:var(--cw);margin-bottom:.2rem;">Verified School Partnerships</h6><p style="font-size:.82rem;color:var(--cm);margin:0;">Qualified students gain access through official school and org verification.</p></div>
          </div>
          <div class="uc p-3" style="display:flex;gap:1rem;align-items:center;">
            <div style="font-size:1.6rem;flex-shrink:0;">🏆</div>
            <div><h6 style="font-size:.92rem;font-weight:600;color:var(--cw);margin-bottom:.2rem;">Structured Mentorship</h6><p style="font-size:.82rem;color:var(--cm);margin:0;">Professional fighters and certified trainers — measurable, accountable programs.</p></div>
          </div>
          <div class="uc p-3" style="display:flex;gap:1rem;align-items:center;">
            <div style="font-size:1.6rem;flex-shrink:0;">📊</div>
            <div><h6 style="font-size:.92rem;font-weight:600;color:var(--cw);margin-bottom:.2rem;">Measurable Outcomes</h6><p style="font-size:.82rem;color:var(--cm);margin:0;">Real results tracked and reported to parents and schools. Not hashtags.</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════ SECTION 3 — ECONOMIC MODEL ════════════ -->
<section class="ueco ns" id="economy">
  <div class="container">
    <div class="text-center mb-5">
      <p class="lbl " sipScrollReveal [sipDelay]="0">Community-Powered Economic Model</p>
      <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">Not Charity.<br><span class="ac">Structured Reinvestment.</span></h2>
      <div class="dv " sipScrollReveal [sipDelay]="0.16" style="margin:1.5rem auto;"></div>
      <p class="tx " sipScrollReveal [sipDelay]="0.24" style="max-width:500px;margin:0 auto;">UMYOBizDFW uses a transparent revenue distribution model. Every dollar that comes in gets reinvested locally — into students, families, and DFW communities.</p>
    </div>
    <div class="row align-items-center g-5">
      <div class="col-lg-5 " sipScrollReveal [sipDelay]="0.32">
        <div style="display:flex;justify-content:center;">
          <div class="urr"><div class="uri"><span>Revenue</span><strong>Distribution</strong></div></div>
        </div>
        <div style="display:flex;justify-content:center;flex-wrap:wrap;gap:.6rem;margin-top:1.2rem;">
          <span style="display:flex;align-items:center;gap:.4rem;font-size:.77rem;color:var(--cm);font-family:var(--fb);"><span style="width:10px;height:10px;border-radius:50%;background:var(--cc);box-shadow:0 0 6px var(--cc);display:inline-block;"></span>Anti-Bullying 20%</span>
          <span style="display:flex;align-items:center;gap:.4rem;font-size:.77rem;color:var(--cm);font-family:var(--fb);"><span style="width:10px;height:10px;border-radius:50%;background:#0057c8;display:inline-block;"></span>DSA 15%</span>
          <span style="display:flex;align-items:center;gap:.4rem;font-size:.77rem;color:var(--cm);font-family:var(--fb);"><span style="width:10px;height:10px;border-radius:50%;background:#003aaa;display:inline-block;"></span>Members Fund 15%</span>
          <span style="display:flex;align-items:center;gap:.4rem;font-size:.77rem;color:var(--cm);font-family:var(--fb);"><span style="width:10px;height:10px;border-radius:50%;background:#002060;display:inline-block;"></span>Operations 50%</span>
        </div>
      </div>
      <div class="col-lg-7 " sipScrollReveal [sipDelay]="0.4">
        <div class="uri2">
          <div class="urd" style="background:var(--cc);box-shadow:0 0 8px var(--cc);"></div>
          <div><h6>20% → Anti-Bullying Associations</h6><p>Direct revenue flows to participating anti-bullying organizations across DFW — funding real change.</p></div>
        </div>
        <div class="uri2">
          <div class="urd" style="background:#0057c8;box-shadow:0 0 8px #0057c8;"></div>
          <div><h6>15% → Dallas Security Academy</h6><p>Expansion of facilities, training programs, and certified staff for broader student access.</p></div>
        </div>
        <div class="uri2">
          <div class="urd" style="background:#003aaa;box-shadow:0 0 8px #003aaa;"></div>
          <div><h6>15% → Members-Owned Expansion Fund</h6><p>Community-controlled capital reinvested into DFW neighborhoods, families, and businesses.</p></div>
        </div>
        <p class="lbl mt-3 mb-2">Funds Support:</p>
        <div>
          <span class="utag">📚 Student Programs</span><span class="utag">🏢 Facility Expansion</span>
          <span class="utag">🚌 Transportation</span><span class="utag">🏠 Mortgage Assistance</span>
          <span class="utag">🚗 Car Note Assistance</span><span class="utag">⛽ Gas &amp; Food Cards</span>
          <span class="utag">⚡ Electric Bill Assistance</span><span class="utag">🎁 Business Giveaways</span>
          <span class="utag">💵 Community Cash Reinvestment</span>
        </div>
        <div class="uhlb">
          <p>When businesses grow, families stabilize. When families stabilize, <strong style="color:var(--cc);">students succeed.</strong></p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════ SECTION 4 — FOR BUSINESSES ════════════ -->
<section class="ubiz ns" id="biz">
  <div class="container">
    <div class="row g-5 align-items-start">
      <div class="col-lg-6">
        <p class="lbl " sipScrollReveal [sipDelay]="0">For DFW Businesses</p>
        <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">The Student Impact<br><span class="ac">Partnership Program</span></h2>
        <div class="dv " sipScrollReveal [sipDelay]="0.16"></div>
        <p class="tx " sipScrollReveal [sipDelay]="0.24" style="margin-bottom:2rem;">DFW businesses can directly impact a student's life while receiving <strong style="color:var(--cw);">structured, measurable brand visibility</strong>. Traditional advertising is expensive and disconnected from real community impact — UMYOBizDFW changes that.</p>
        <div class="ubf " sipScrollReveal [sipDelay]="0.32"><div class="ubn">01</div><div><h6>Banner &amp; Logo at Training Facilities</h6><p>Hyper-local branding directly where DFW youth and families gather.</p></div></div>
        <div class="ubf " sipScrollReveal [sipDelay]="0.4"><div class="ubn">02</div><div><h6>Weekly Podcast &amp; Radio Mentions</h6><p>Regular audio exposure to a highly engaged, trust-based DFW audience.</p></div></div>
        <div class="ubf " sipScrollReveal [sipDelay]="0.48"><div class="ubn">03</div><div><h6>UFC Fighter Platform Exposure</h6><p>Branded exposure on Kennedy Nzechukwu's platforms — 100K+ reach.</p></div></div>
        <div class="ubf " sipScrollReveal [sipDelay]="0.56"><div class="ubn">04</div><div><h6>Social Media Video Commercials</h6><p>Youth-created commercial contests + product placement and live giveaways.</p></div></div>
        <div class="ubf " sipScrollReveal [sipDelay]="0.64"><div class="ubn">05</div><div><h6>DFW Digital Coupon Booklet + Events</h6><p>Marketplace listing, event promotion, and DFW virtual conference access.</p></div></div>
      </div>
      <div class="col-lg-6">
        <div class="ubc " sipScrollReveal [sipDelay]="0">
          <div style="font-size:3rem;margin-bottom:1rem;">🤝</div>
          <h4>Become a Youth Impact Partner</h4>
          <p style="color:var(--cm);font-size:.93rem;line-height:1.75;margin-bottom:1.5rem;font-family:var(--fb);">Through our Student Impact Partnership Program, businesses do more than advertise — they help change lives. Your brand becomes synonymous with building stronger DFW youth.</p>
          <a href="/#partner" class="btn-c" >Become a Youth Impact Partner</a>
        </div>
        <div class="uc p-4 mt-3 " sipScrollReveal [sipDelay]="0.08">
          <p class="lbl mb-3">Why Businesses Choose UMYOBizDFW</p>
          <div style="display:flex;flex-direction:column;gap:1.1rem;">
            <div><div style="display:flex;justify-content:space-between;font-size:.78rem;color:var(--cm);margin-bottom:5px;font-family:var(--fb);"><span>Brand Trust &amp; Community Goodwill</span><span style="color:var(--cc);">High</span></div><div class="upb"><div class="upf" style="width:88%;"></div></div></div>
            <div><div style="display:flex;justify-content:space-between;font-size:.78rem;color:var(--cm);margin-bottom:5px;font-family:var(--fb);"><span>Local Audience Reach</span><span style="color:var(--cc);">Exclusive DFW</span></div><div class="upb"><div class="upf" style="width:94%;"></div></div></div>
            <div><div style="display:flex;justify-content:space-between;font-size:.78rem;color:var(--cm);margin-bottom:5px;font-family:var(--fb);"><span>Cost vs Traditional Advertising</span><span style="color:var(--cc);">Lower</span></div><div class="upb"><div class="upf" style="width:75%;"></div></div></div>
            <div><div style="display:flex;justify-content:space-between;font-size:.78rem;color:var(--cm);margin-bottom:5px;font-family:var(--fb);"><span>Measurable Community Impact</span><span style="color:var(--cc);">Tracked</span></div><div class="upb"><div class="upf" style="width:82%;"></div></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════ SECTION 5 — FOR RESIDENTS ════════════ -->
<section class="ures ns" id="residents">
  <div class="container">
    <div class="row align-items-center g-5">
      <div class="col-lg-5 text-center text-lg-start" sipScrollReveal [sipDelay]="0">
        <p class="lbl">For DFW Residents</p>
        <div class="upr"><sup>$</sup>2.54<span style="font-size:1.4rem;color:var(--cm);">/mo</span></div>
        <p style="color:var(--cm);font-size:.82rem;letter-spacing:.08em;text-transform:uppercase;margin-top:.4rem;font-family:var(--fb);">Membership starts at</p>
        <p class="tx mt-3">Priced for accessibility. Structured for inclusion. Every DFW resident deserves a safe digital home — away from negativity, exploitation, and national noise.</p>
        <a href="/#registration-form" class="btn-c d-inline-block mt-3" >Join the Community</a>
      </div>
      <div class="col-lg-7 " sipScrollReveal [sipDelay]="0.08">
        <p class="lbl mb-1">A Safe Digital Home for DFW</p>
        <h2 class="hd2 mb-4">If you're tired of the noise —<br><span class="ac">this is your alternative.</span></h2>
        <div class="uri3"><div class="uico">🔐</div><div><h6>Privacy Protection</h6><p>A gated platform built exclusively for DFW. No data harvesting, no surveillance algorithms.</p></div></div>
        <div class="uri3"><div class="uico">🤲</div><div><h6>Trusted Local Connections</h6><p>Verified community members. Real relationships. No anonymous toxicity or national noise.</p></div></div>
        <div class="uri3"><div class="uico">🎁</div><div><h6>Community Giveaways &amp; Discounts</h6><p>Exclusive discount programs and community giveaways from local DFW businesses.</p></div></div>
        <div class="uri3"><div class="uico">📅</div><div><h6>Events &amp; Virtual Conferences</h6><p>Access to DFW events, virtual conferences, and secure community networking.</p></div></div>
        <div class="uri3"><div class="uico">🛡️</div><div><h6>Anti-Bullying Updates &amp; Youth Resources</h6><p>Stay connected with DFW student programs and structured youth initiatives.</p></div></div>
      </div>
    </div>
  </div>
</section>

<!-- ════════════ SECTION 6 — WHY NOW ════════════ -->
<section class="uwhy ns" id="whynow">
  <div class="container">
    <div class="text-center mb-5">
      <p class="lbl " sipScrollReveal [sipDelay]="0">Why Now?</p>
      <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">DFW is Growing Fast.<br><span class="ac">Growth Needs Structure.</span></h2>
      <div class="dv " sipScrollReveal [sipDelay]="0.24" style="margin:1.5rem auto;"></div>
      <p class="tx " sipScrollReveal [sipDelay]="0.32" style="max-width:500px;margin:0 auto;">Dallas–Fort Worth is one of the fastest-growing regions in America. But rapid growth without structure creates serious, measurable problems. <strong style="color:var(--cw);">This is not a trend. This is infrastructure.</strong></p>
    </div>
    <div class="row g-4">
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0"><div class="uc upc h-100"><div class="upi">🏘️</div><h5>Community Disconnection</h5><p>Rapid growth pulls neighbors apart. Without a structured local platform, residents lose the connections that make neighborhoods resilient.</p></div></div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.08"><div class="uc upc h-100"><div class="upi">👧</div><h5>Youth Vulnerability</h5><p>Students face bullying, digital exploitation, and lack of mentorship. Without community support, youth fall through the cracks that rapid urban growth creates.</p></div></div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.16"><div class="uc upc h-100"><div class="upi">💸</div><h5>Economic Leakage</h5><p>Local dollars flow out to national platforms and corporations. DFW money should build DFW neighborhoods — not Wall Street profits.</p></div></div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.24"><div class="uc upc h-100"><div class="upi">🔓</div><h5>Digital Exploitation</h5><p>Residents unprotected from data harvesting, surveillance, and manipulative algorithms designed to keep you engaged, not empowered.</p></div></div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.32"><div class="uc upc h-100"><div class="upi">📢</div><h5>Rising Advertising Costs</h5><p>Small local businesses priced out of effective advertising by big-tech platforms who don't care about DFW communities.</p></div></div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.4"><div class="uc upc h-100" style="background:rgba(0,212,255,.06);border-color:rgba(0,212,255,.25);"><div class="upi" style="background:rgba(0,212,255,.15);border-color:rgba(0,212,255,.35);">🛡️</div><h5>UMYOBizDFW Is the Answer</h5><p>Real problems. Measurable solutions. A privacy-gated, student-centered, community-powered platform — built exclusively for Dallas–Fort Worth.</p></div></div>
    </div>
  </div>
</section>

<!-- ════════════ SECTION 7 — OUR GOAL ════════════ -->
<section class="ugoal ns" id="goal">
  <div class="ugbg">DFW</div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="text-center">
      <p class="lbl " sipScrollReveal [sipDelay]="0">Our Goal</p>
      <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">One Protected <span class="ac">Ecosystem</span></h2>
      <div class="dv " sipScrollReveal [sipDelay]="0.16" style="margin:1.5rem auto;"></div>
      <p class="tx " sipScrollReveal [sipDelay]="0.24" style="max-width:480px;margin:0 auto;">To register every DFW resident, business, organization, anti-bullying association, school and youth group — under one unified, secure, protected network.</p>
    </div>
    <div class="ugg " sipScrollReveal [sipDelay]="0.32">
      <div class="ugc"><div class="gi">🏙️</div><h5>Every Resident</h5><p>All of DFW represented and protected</p></div>
      <div class="ugc"><div class="gi">💼</div><h5>Every Business</h5><p>Local commerce growing within the ecosystem</p></div>
      <div class="ugc"><div class="gi">🏫</div><h5>Every School</h5><p>Education and safety in one network</p></div>
      <div class="ugc"><div class="gi">🤝</div><h5>Every Organization</h5><p>Nonprofits and associations unified</p></div>
      <div class="ugc"><div class="gi">🛡️</div><h5>Anti-Bullying Assoc.</h5><p>Funded partnerships fighting bullying together</p></div>
      <div class="ugc" style="background:rgba(0,212,255,.05);"><div class="gi">⭐</div><h5>One Stronger DFW</h5><p>United. Protected. Invested in each other.</p></div>
    </div>
  </div>
</section>

<!-- HOW IT WORKS — REDESIGNED -->

<section class="uhiw ns" id="how">
  <div class="container" style="position:relative;z-index:1;">
    <div class="text-center mb-5">
      <p class="lbl " sipScrollReveal [sipDelay]="0">How It Works</p>
      <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">Simple. <span class="ac">Structured. Secure.</span></h2>
      <div class="dv " sipScrollReveal [sipDelay]="0.16" style="margin:1.5rem auto;"></div>
      <p class="tx " sipScrollReveal [sipDelay]="0.24" style="max-width:480px;margin:0 auto;">UMYOBizDFW is built on three core pillars that make it unlike any other platform in Dallas–Fort Worth.</p>
    </div>
    <div class="row g-4 position-relative">
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0">
        <div class="uc uhiw-step h-100">
          <div class="uhiw-num">01</div>
          <div class="uhiw-icon">🔐</div>
          <div>
            <h3>Private &amp; Safe Digital Communities</h3>
            <p>Each organization gets its own exclusive, gated digital platform — tailored for its members, offering verified secure private networking with zero tolerance for negativity.</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.08">
        <div class="uc uhiw-step h-100">
          <div class="uhiw-num">02</div>
          <div class="uhiw-icon">⚙️</div>
          <div>
            <h3>Comprehensive Services</h3>
            <p>Our tech firm handles all maintenance, hosting, tech support, and day-to-day updates — so your organization can stay focused on its mission, not the backend.</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.16">
        <div class="uc uhiw-step h-100">
          <div class="uhiw-num">03</div>
          <div class="uhiw-icon">💰</div>
          <div>
            <h3>Revenue Sharing</h3>
            <p>UMYO shares up to 15% of membership fees with partnering organizations and up to 15% back with members — creating a sustainable, community-first financial model.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- step connector line -->
    <div class=" mt-5" sipScrollReveal [sipDelay]="0.24" style="display:flex;align-items:center;justify-content:center;gap:0;">
      <div style="flex:1;height:1px;background:linear-gradient(90deg,transparent,var(--cc));"></div>
      <div style="width:10px;height:10px;border-radius:50%;background:var(--cc);box-shadow:0 0 10px var(--cc);flex-shrink:0;"></div>
      <div style="flex:1;height:1px;background:linear-gradient(90deg,var(--cc),transparent);"></div>
    </div>
    <div class=" text-center mt-4" sipScrollReveal [sipDelay]="0.32">
      <p style="font-style:italic;color:var(--cm);font-size:.95rem;font-family:var(--fb);margin:0;">
        "Built by the community, for the community — where every member grows, and every dollar stays local."
      </p>
    </div>
  </div>
</section>

<!-- ════════════════════════════════════════════════
     PRICING — REDESIGNED
════════════════════════════════════════════════ -->
<section class="upricing ns" id="pricing">
  <div class="container">
    <div class="text-center mb-5">
      <div class="upc-badge " sipScrollReveal [sipDelay]="0">Official Launch Special</div>
      <p class="lbl " sipScrollReveal [sipDelay]="0.08">Membership Plans</p>
      <h2 class="hd2 " sipScrollReveal [sipDelay]="0.16">UMYO DFW <span class="ac">Launch Pricing</span></h2>
      <div class="dv " sipScrollReveal [sipDelay]="0.24" style="margin:1.5rem auto;"></div>
      <p class="tx " sipScrollReveal [sipDelay]="0.32" style="max-width:440px;margin:0 auto;">Lifetime Membership Offers — First 5,000 Members Only. Lock in your rate today.</p>
    </div>
    <div class="row g-4 justify-content-center">

      <!-- Plan 1 -->
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0">
        <div class="upc-card h-100">
          <p class="upc-price">$9<span style="font-size:2rem;">.99</span></p>
          <p class="upc-price-sub">per month</p>
          <p class="upc-title">Individuals &amp; Families</p>
          <p class="upc-desc">Perfect for residents who want trusted local connections, privacy, and community access.</p>
          <div class="upc-divider"></div>
          <div class="upc-feat"><span class="dot">✓</span><span>5 Digital Cards</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>3 Images</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>Social Media Links</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>Community Access</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>Event &amp; Group Invites</span></div>
          <a href="https://umyobizdfw.com/" class="btn-o d-block text-center mt-4" target="_blank" style="font-size:.8rem;padding:.75rem;">Get Started</a>
        </div>
      </div>

      <!-- Plan 2 — Featured -->
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.08">
        <div class="upc-card featured h-100">
          <div class="upc-featured-badge">Most Popular</div>
          <p class="upc-price">$19<span style="font-size:2rem;">.99</span></p>
          <p class="upc-price-sub">per month</p>
          <p class="upc-title">Active Civic Participants</p>
          <p class="upc-desc">For community leaders, local advocates, and civic-minded DFW members who want full visibility.</p>
          <div class="upc-divider"></div>
          <div class="upc-feat"><span class="dot">✓</span><span>20 Digital Cards</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>3 Images + Logo</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>20 Community Posts</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>Community Access</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>Custom Profile Banner</span></div>
          <a href="https://umyobizdfw.com/" class="btn-c d-block text-center mt-4" target="_blank" style="font-size:.8rem;padding:.75rem;">Get Started</a>
        </div>
      </div>

      <!-- Plan 3 -->
      <div class="col-md-4 " sipScrollReveal [sipDelay]="0.24">
        <div class="upc-card h-100">
          <p class="upc-price" style="font-size:2.8rem;">$109<span style="font-size:1.5rem;">.99</span></p>
          <p class="upc-price-sub">per month</p>
          <p class="upc-title">Businesses &amp; Organizations</p>
          <p class="upc-desc">Full business exposure, community alignment, and access to giveaways, broadcasts, and campaigns.</p>
          <div class="upc-divider"></div>
          <div class="upc-feat"><span class="dot">✓</span><span>20 Digital Cards</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>3 Images + Logo</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>20 Videos or Promotions</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>Community Access</span></div>
          <div class="upc-feat"><span class="dot">✓</span><span>Giveaways, Broadcasts &amp; Targeted Campaigns</span></div>
          <a href="https://umyobizdfw.com/" class="btn-o d-block text-center mt-4" target="_blank" style="font-size:.8rem;padding:.75rem;">Get Started</a>
        </div>
      </div>

    </div>
    <div class="upc-note mt-4" sipScrollReveal [sipDelay]="0.32">
      <p>⏱️ <strong style="color:var(--cw);">First 5,000 Members Only.</strong> All members become eligible for weekly giveaways after 60 days. Higher plans offer greater visibility and local perks.</p>
    </div>
  </div>
</section>

<!-- CAROUSEL  -->
<div class="ucarousel-wrap">
  <div class="ucarousel-label"><span>DFW Platform Features</span></div>
</div>
<section class="organization">
  <div class="slider overflow-hidden" id="logos">
    <div id="gallery1" class="mx-md-0 mx-3">
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Appt_booking.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Critical_Thinking.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/dfw_daily_news.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/dfw_dating.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Digital_coupons.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/dfw_digital_mag.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_estore.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Events.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Fans.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/dfw_games.png" alt=""></a></div>
    </div>
    <div id="gallery" dir="rtl">
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/dfw_giveaways.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Livestream.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_menopause.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Music.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_RAdio.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Smart_Chats.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Talks.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_Tweets.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/DFW_video.png" alt=""></a></div>
      <div class="slide"><a href="#"><img class="lozad" src="assetses/img/scrolling_images/dfw_vpn.png" alt=""></a></div>
    </div>
  </div>
</section>
<section class="ufaq ns" id="faq">
  <div class="container" style="position:relative;z-index:1;">

    <div class="text-center mb-5">
      <p class="lbl " sipScrollReveal [sipDelay]="0">Got Questions?</p>
      <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">Frequently Asked <span class="ac">Questions</span></h2>
      <div class="dv " sipScrollReveal [sipDelay]="0.16" style="margin:1.5rem auto;"></div>
      <p class="tx " sipScrollReveal [sipDelay]="0.24" style="max-width:460px;margin:0 auto;">Everything you need to know about UMYOBizDFW — the community, the model, and how to get started.</p>
    </div>

    <div class="row g-5 align-items-start">

      <!-- Accordion -->
      <div class="col-lg-7 " sipScrollReveal [sipDelay]="0.08">
        <div class="accordion" id="faqAcc">

          <div class="ufaq-item accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button ufaq-btn" type="button" data-bs-toggle="collapse" data-bs-target="#fq1">
                How do we take back our communities?
              </button>
            </h2>
            <div id="fq1" class="accordion-collapse collapse show" data-bs-parent="#faqAcc">
              <div class="accordion-body ufaq-body">
                By choosing platforms built for our benefit. We must support networks that <strong>empower residents</strong>, not exploit them. UMYOBizDFW was built specifically for Dallas–Fort Worth — to keep local voices, local dollars, and local power inside our community.
              </div>
            </div>
          </div>

          <div class="ufaq-item accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button ufaq-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fq2">
                Do I need to leave other platforms?
              </button>
            </h2>
            <div id="fq2" class="accordion-collapse collapse" data-bs-parent="#faqAcc">
              <div class="accordion-body ufaq-body">
                No. You can share your content from UMYOBizDFW to other platforms. But building a presence here ensures you <strong>own your data</strong> and gain community-first support — without being at the mercy of national algorithms.
              </div>
            </div>
          </div>

          <div class="ufaq-item accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button ufaq-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fq3">
                Is UMYO DFW Black-owned?
              </button>
            </h2>
            <div id="fq3" class="accordion-collapse collapse" data-bs-parent="#faqAcc">
              <div class="accordion-body ufaq-body">
                Yes. Founded by a Nubian father and his three sons, UMYOBizDFW is <strong>community-owned and inclusive</strong> — focused on unity, growth, and empowerment across all backgrounds in Dallas–Fort Worth.
              </div>
            </div>
          </div>

          <div class="ufaq-item accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button ufaq-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fq4">
                Is my data secure?
              </button>
            </h2>
            <div id="fq4" class="accordion-collapse collapse" data-bs-parent="#faqAcc">
              <div class="accordion-body ufaq-body">
                Yes. We only store basic contact info for networking purposes. Your data is <strong>never sold or harvested</strong>. Payment is securely handled via Stripe or PayPal. Privacy protection is a core feature — not an afterthought.
              </div>
            </div>
          </div>

          <div class="ufaq-item accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button ufaq-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fq5">
                What are the platform costs?
              </button>
            </h2>
            <div id="fq5" class="accordion-collapse collapse" data-bs-parent="#faqAcc">
              <div class="accordion-body ufaq-body">
                <ul class="ufaq-list">
                  <li><strong style="color:var(--cw);">$9.99/month</strong> — Individuals &amp; Families</li>
                  <li><strong style="color:var(--cw);">$19.99/month</strong> — Civic &amp; Active Participants</li>
                  <li><strong style="color:var(--cw);">$109.99/month</strong> — Businesses &amp; Organizations</li>
                </ul>
                <p style="margin-top:.8rem;font-size:.84rem;">All members eligible for weekly giveaways after 60 days.</p>
              </div>
            </div>
          </div>

          <div class="ufaq-item accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button ufaq-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fq6">
                What makes UMYOBizDFW different?
              </button>
            </h2>
            <div id="fq6" class="accordion-collapse collapse" data-bs-parent="#faqAcc">
              <div class="accordion-body ufaq-body">
                <ul class="ufaq-list">
                  <li>The community does the marketing — not paid algorithms</li>
                  <li>Real-time networking, chats, and collaboration tools</li>
                  <li>Directories searchable by name, business, school, or region</li>
                  <li>Daily livestreams, custom profiles, and zero negativity</li>
                  <li>Revenue flows back to DFW students, families, and associations</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="ufaq-item accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button ufaq-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fq7">
                How do I register?
              </button>
            </h2>
            <div id="fq7" class="accordion-collapse collapse" data-bs-parent="#faqAcc">
              <div class="accordion-body ufaq-body">
                <ul class="ufaq-list">
                  <li>Visit <a href="https://umyobizdfw.com/" target="_blank">umyobizdfw.com</a></li>
                  <li>Go to the <strong>Directories</strong> section on the homepage</li>
                  <li>Choose your category — Resident, Business, Org, etc.</li>
                  <li>Click <strong>Registration</strong> and complete the form</li>
                  <li>Choose your plan and pay securely — invite code arrives by email</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Right sticky CTA card -->
      <div class="col-lg-5" sipScrollReveal [sipDelay]="0.08" style="transition-delay:.15s;">
        <div class="ufaq-cta-card">
          <h4>Still have<br><span>questions?</span></h4>
          <p>Our team is here to walk you through setup, answer your questions, and help you find the right membership for your needs — whether you're a resident, business, school, or organization.</p>
          <div class="ufaq-quick">
            <div class="ufaq-quick-item"><span class="qi">🔐</span><span>Privacy protected — your data stays in DFW</span></div>
            <div class="ufaq-quick-item"><span class="qi">💳</span><span>Secure payment via Stripe or PayPal</span></div>
            <div class="ufaq-quick-item"><span class="qi">🎁</span><span>Giveaway eligible after 60 days</span></div>
            <div class="ufaq-quick-item"><span class="qi">🏙️</span><span>100% built for Dallas–Fort Worth</span></div>
          </div>
          <a href="/#registration-form" class="btn-c d-block text-center" >Join UMYOBizDFW Today</a>
          <p style="text-align:center;margin-top:1rem;font-size:.78rem;color:var(--cm);font-family:var(--fb);">Starting at just <strong style="color:var(--cc);">$2.54/month</strong></p>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ════════════ FINAL CTA ════════════ -->
<section class="ucta ns">
  <div class="uctag"></div>
  <div class="container" style="position:relative;z-index:1;">
    <p class="lbl " sipScrollReveal [sipDelay]="0">Join the Movement Today</p>
    <h2 class="" sipScrollReveal [sipDelay]="0.08">Be Part of<br><span>Something Real.</span></h2>
    <div class="" sipScrollReveal [sipDelay]="0.16" style="max-width:540px;margin:0 auto;">
      <p class="ubl">
        <strong>When Dallas protects its students,</strong> Fort Worth protects its future.<br>
        <strong>When businesses reinvest locally,</strong> neighborhoods stabilize.<br>
        <strong>When community unites,</strong> bullying loses power.
      </p>
    </div>

    <div class="ucs " sipScrollReveal [sipDelay]="0.32">
      <div class="text-center"><div class="ucn">$2.54</div><div class="ucl">Monthly Membership</div></div>
      <div class="ucvd"></div>
      <div class="text-center"><div class="ucn">DFW</div><div class="ucl">Exclusive Region</div></div>
      <div class="ucvd"></div>
      <div class="text-center"><div class="ucn">1</div><div class="ucl">Unified Ecosystem</div></div>
      <div class="ucvd"></div>
      <div class="text-center"><div class="ucn">100K+</div><div class="ucl">UFC Platform Reach</div></div>
    </div>
  </div>
</section>

<!-- ════════ FOOTER ════════ -->
<footer class="ufoot">
  <div class="container">
    <img src="assetses/img/logo.png" alt="UMYOBizDFW" onerror="this.style.display='none'">
    <div class="ufb">UMYOBizDFW</div>
    <p>DFW's First Privacy-Gated Digital Community</p>
    <div class="d-flex justify-content-center gap-4 flex-wrap">
      <a href="/">Home</a>
      <a href="/about">About Us</a>
      <a routerLink="/networks">Network</a>
      <a routerLink="/hub">Hub</a>
      <a routerLink="/anti-bullying">Anti-Bullying</a>
      <a routerLink="/community-impact">Community Fund</a>
      <a routerLink="/empower-youth">Empower Youth</a>
      <a routerLink="/services">Type of Servcies</a>
      <a routerLink="/cf">Card Features</a>
      <a href="/terms">Terms &amp; Conditions</a>
    </div>
    <p class="ufc2">© 2025 UMYOBizDFW · Built by the community, for the community</p>
  </div>
</footer>